import clsx from 'clsx';

export const ModalTitle = ({
  title,
  includeTitleDot,
  className,
  style,
  id,
}: {
  title: string;
  includeTitleDot?: boolean;
  className?: string;
  style?: React.CSSProperties;
  /** Set so a dialog can point `aria-labelledby` at this heading. */
  id?: string;
}) => (
  <h1
    id={id}
    className={clsx('text-2xl font-bold leading-normal text-white', className)}
    style={style}
  >
    {title}
    {includeTitleDot && <span className="text-palette-600">.</span>}
  </h1>
);
